export enum SlideDirection {
  left = 'left',
  right = 'right'
}